import { mapState, mapActions, mapGetters } from 'vuex'
import { orderEvents, orderFields } from '@/const'
import Modal from '@/components/modals/modal/modal.vue'
import BeforeAfterEvent from '@/components/before-after-event/before-after-event.vue'
import Loader from '@/components/loader/loader.vue'
import IcBicycle from '@/assets/svg/ic_bicycle.svg?inline'
import IcCar from '@/assets/svg/ic-car.svg?inline'
import IcArrowExpand from '@/assets/svg/ic-arrow-expand.svg?inline'
import formatFunctons from '@/components/mixins/format-functions'
import copyTextMixin from '@/components/mixins/copy-text-mixin'
import { getSecondsToTime } from '@/utils/format-strings'

export default {
  name: 'OrderHistoryModal',
  /**
   * formatFuncton:
   *  getFormatDate
   *  getShortId
   *  getCookedTime
   *
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [formatFunctons, copyTextMixin],
  props: {
    /**
     * объект из детальной страницы заказа
     */
    orderInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    BeforeAfterEvent,
    Loader,
    IcBicycle,
    IcCar,
    IcArrowExpand
  },
  static() {
    return {
      orderEvents,
      orderFields
    }
  },
  data() {
    const tabs = [
      {
        id: 'events',
        name: 'Статусы и события'
      },
      {
        id: 'changes',
        name: 'Все изменения'
      }
    ]
    return {
      historyData: null,
      loading: false,
      tabs,
      activeTab: tabs[0].id,
      itemIdArr: [],
      itemsSorted: []
    }
  },
  computed: {
    ...mapState({
      orderStatuses: state => state.sharedData.orderStatuses
    }),
    ...mapGetters({
      isAutoRouteTaskActive: 'logistics/isAutoRouteTaskActive' // Теперь это вычисляемое свойство
    }),
    isEmptyVisibleData() {
      if (this.historyData) {
        return !this.historyData[this.activeTab].length
      }
      return true
    },
    currentTabs() {
      if (this.historyData && this.historyData.items) {
        return [
          ...this.tabs,
          {
            id: 'items',
            name: 'Блюда'
          }
        ]
      }
      return this.tabs
    }
  },
  methods: {
    ...mapActions({
      getRouteTaskById: 'routeTasks/getRouteTaskById',
      getOrderHistory: 'orders/getOrderHistory'
    }),
    getSecondsToTime,
    getAggregatedData(items) {
      /**
       * заполняем изначальными значениями
       */
      const start = {
        phase: 'Весь процесс',
        /**
         * в reduce преобразуется к 1 января 1970
         */
        finish_at: 0,
        kitchen_time: 0,
        queue_time: 0,
        baking_time: 0,
        cooking_time: 0,
        deviation: 0,
        time_standard: 0
      }
      /**
       * не изменяемые поля
       */
      const notModifiedFields = ['item_id', 'title', 'workshop']
      for (const field of notModifiedFields) {
        start[field] = items[0][field]
      }
      return items.reduce(
        (result, item, index) => {
          const finishAtResult = this.$moment(result.finish_at)
          const finishAtItem = this.$moment(item.finish_at)
          if (finishAtItem.diff(finishAtResult) > 0) {
            result.finish_at = finishAtItem.format()
          }

          result.kitchen_time = result.kitchen_time + item.kitchen_time

          result.queue_time = result.queue_time + item.queue_time

          if (item.baking_time) {
            if (result.baking_time) {
              result.baking_time = result.baking_time + item.baking_time
            } else {
              result.baking_time = item.baking_time
            }
          }

          if (item.time_standard !== null) {
            result.cooking_time = result.cooking_time + item.cooking_time
            result.time_standard = result.time_standard + item.time_standard
          }

          if (index === items.length - 1) {
            result.deviation = Math.round((result.cooking_time / result.time_standard) * 100 - 100)
          }

          return result
        },
        { ...start }
      )
    },
    async getHistoryData() {
      try {
        this.loading = true
        this.historyData = await this.getOrderHistory(this.orderInfo.order_id)
        this.itemIdArr = []
        this.itemsSorted = []
        if (this.historyData.items) {
          const itemsSortedMap = new Map()
          let phases = []
          for (let i = 0; i < this.historyData.items.length; i++) {
            const item = this.historyData.items[i]
            const itemPrev = i !== 0 ? this.historyData.items[i - 1] : null
            if (i === 0 || (itemPrev && itemPrev.item_id !== item.item_id)) {
              phases = [item.phase]
              itemsSortedMap.set(item.item_id, [item])
            } else {
              const existPhases = phases.filter(ph => ph === item.phase)
              if (existPhases.length) {
                item.phase = `${item.phase} ${existPhases.length + 1}`
              }
              const sortedGroupArr = itemsSortedMap.get(item.item_id)
              sortedGroupArr.push(item)
              phases.push(item.phase)
            }
          }
          for (const items of itemsSortedMap) {
            items[1].unshift(this.getAggregatedData(items[1]))
          }
          this.itemsSorted = Array.from(itemsSortedMap.entries())
          this.itemIdArr = Array.from(itemsSortedMap.keys())
        } else if (this.activeTab === 'items') {
          this.activeTab = 'events'
        }
        this.$emit('history-refreshed')
      } catch (e) {
        this.hide()
        throw e
      } finally {
        this.loading = false
      }
    },
    show() {
      this.$refs.modal.show()
      this.getHistoryData()
    },
    hide() {
      this.$refs.modal.hide()
    },
    getRoutTaskText(order, isShort = false) {
      if (typeof order === 'string') {
        return `м ${order}`
      }
      return `м ${isShort ? this.getShortId(order.route_task_info.id) : order.route_task_info.id}${
        order.route_task_info.allowed_by_foot_courier ? ' (в)' : ''
      }`
    },
    selectRouteTask(event, order) {
      if (this.isShiftPress) {
        this.onCopyText(event, this.getRoutTaskText(order))
        return
      }
      this.setRouteTask(typeof order === 'string' ? order : order.route_task_info.id)
    },
    setRouteTask(id) {
      this.getRouteTaskById(id)
      this.hide()
    },
    expandItem(event) {
      if (this.itemIdArr.find(id => id === event.item_id)) {
        this.itemIdArr = this.itemIdArr.filter(id => id !== event.item_id)
      } else {
        this.itemIdArr.push(event.item_id)
      }
    }
  }
}
